export default "__VITE_ASSET__DdcUF9yI__"